import React, { useLayoutEffect, useState } from "react";
import deData from './Localization/locales/de.json';
import enData from './Localization/locales/en.json';
import { AppBar, ButtonBase, ClickAwayListener, Grid, MenuItem, MenuList, Paper, Popper, Toolbar, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import PersonIcon from '@material-ui/icons/Person';
import "./styles/MenuStyles.css";
import { makeStyles } from "@material-ui/core/styles";
var MENUNAV_LEFT_SIDEBAR_BREAKPOINT = 800;
var MenuNav = function (props) {
    var _a = useState(null), nestedAnchorEl = _a[0], setNestedAnchorEl = _a[1];
    var _b = useState(null), userAnchorEl = _b[0], setUserAnchorEl = _b[1];
    var handleUserItemClick = function (event) { return setUserAnchorEl(event.currentTarget); };
    var handleUserMenuClose = function () { return setUserAnchorEl(null); };
    var handleNestedItemClick = function (index, event) { return setNestedAnchorEl([index, event.currentTarget]); };
    var handleNestedItemMenuClose = function () { return setNestedAnchorEl(null); };
    var tempHeader;
    if (!props.headerSize) {
        tempHeader = 55; //55 is the default headersize
    }
    else {
        tempHeader = props.headerSize;
    }
    var _c = useState(tempHeader), logoHeight = _c[0], setLogoHeight = _c[1];
    var _d = useState(true), leftSidebarInDOM = _d[0], setLeftSidebarInDOM = _d[1];
    var handleShowLeftSidebar = function (displayLeftMenu) {
        var viewSize;
        if (displayLeftMenu) {
            viewSize = "250px";
        }
        else {
            viewSize = "";
        }
        var menuContent = document.getElementById("menuContent");
        if (menuContent !== null) {
            menuContent.style.width = viewSize;
        }
        var mainContent = document.getElementById("mainContent");
        if (mainContent !== null) {
            mainContent.style.marginLeft = viewSize;
        }
    };
    useLayoutEffect(function () {
        function resizeOccured() {
            // Hide left sidebar
            if (window.innerWidth > MENUNAV_LEFT_SIDEBAR_BREAKPOINT) {
                handleShowLeftSidebar(false);
            }
            if (props.headerSize) {
                if (window.innerWidth > MENUNAV_LEFT_SIDEBAR_BREAKPOINT)
                    setLogoHeight(props.headerSize);
            }
            //Take left sidebar completely out of the DOM if there's a central element present
            //AND window size sufficiently large
            if (props.centralElement
                && window.innerWidth > MENUNAV_LEFT_SIDEBAR_BREAKPOINT) {
                setLeftSidebarInDOM(false);
            }
            else
                setLeftSidebarInDOM(true);
        }
        window.addEventListener('resize', resizeOccured);
        resizeOccured();
        return function () { return window.removeEventListener('resize', resizeOccured); };
    }, []);
    function renderUserMenuItems() {
        return props.userItems.map(function (item, index) {
            if (!item.show)
                return null;
            return React.createElement(MenuItem, { key: index, onClick: function () {
                    item.onClick();
                    handleUserMenuClose();
                } },
                React.createElement(Typography, { className: "printBackground", variant: 'inherit', color: 'inherit', style: { fontSize: 16 } }, item.name));
        });
    }
    function renderMenuItems() {
        return props.items.map(function (item, index) {
            if (!item.show)
                return null;
            if (item.link !== undefined) {
                return React.createElement(Grid, { key: index, id: "userGrid", className: "libraryUserGrid", item: true },
                    React.createElement(Link, { to: item.link, style: { textDecoration: "none", color: "inherit", padding: "0px" }, onClick: function () {
                            handleShowLeftSidebar(false);
                        } },
                        React.createElement(ButtonBase, { className: "a link menu", style: { padding: '10px' }, "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: item.onClick },
                            React.createElement(Typography, { className: "printBackground", variant: 'inherit', color: 'inherit', style: { fontSize: 14 } }, item.name))));
            }
            return React.createElement(Grid, { key: props.items.length + index, id: "userGrid", className: "libraryUserGrid", item: true },
                React.createElement(ButtonBase, { className: "a link menu", style: { padding: '10px' }, "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: item.onClick },
                    React.createElement(Typography, { className: "printBackground", variant: 'inherit', color: 'inherit', style: { fontSize: 14 } }, item.name)));
        });
    }
    function renderNestedMenuItems(items) {
        return items.map(function (item, index) {
            if (!item.show)
                return null;
            return renderNestedMenuItem(item, index);
        });
    }
    function renderNestedMenuItem(nestedItem, index) {
        if (!nestedItem.show)
            return null;
        var numberOfItems = nestedItem.items.reduce((function (previousValue, currentValue) {
            return currentValue.show ? previousValue + 1 : previousValue;
        }), 0);
        if (numberOfItems === 0)
            return null;
        return React.createElement(Grid, { key: index, id: "userGrid", className: "libraryUserGrid", item: true },
            React.createElement(ButtonBase, { "aria-controls": "simple-menu", style: { padding: '10px' }, "aria-haspopup": "true", onClick: function (event) { return handleNestedItemClick(index, event); } },
                React.createElement(Typography, { className: "printBackground", variant: 'inherit', color: 'inherit', style: { fontSize: 14 } }, nestedItem.name)),
            React.createElement(Menu, { anchorEl: nestedAnchorEl === null ? null : nestedAnchorEl[1], open: nestedAnchorEl === null ? false : nestedAnchorEl[0] === index, onClose: handleNestedItemMenuClose }, renderItemsOfNestedMenuItem(nestedItem)));
    }
    function renderItemsOfNestedMenuItem(nestedItem) {
        return nestedItem.items.map(function (item, index) {
            if (!item.show)
                return null;
            if (item.link !== undefined) {
                return React.createElement(MenuItem, { key: index, onClick: function () {
                        item.onClick();
                        handleNestedItemMenuClose();
                    } },
                    React.createElement(Typography, { className: "printBackground", variant: 'inherit', color: 'inherit', style: { fontSize: 16 } },
                        React.createElement(Link, { to: item.link, style: { color: "black", padding: "0px" }, onClick: function () {
                                handleShowLeftSidebar(false);
                                item.onClick();
                                handleNestedItemMenuClose();
                            } }, item.name)));
            }
            return React.createElement(MenuItem, { onClick: function () {
                    item.onClick();
                    handleNestedItemMenuClose();
                } },
                React.createElement(Typography, { className: "printBackground", variant: 'inherit', color: 'inherit', style: { fontSize: 16 } }, item.name));
        });
    }
    function renderLogo() {
        var logoWidth = logoHeight * 5.5;
        if (props.logoLink !== undefined) {
            return React.createElement(Grid, { className: props.centralElement ? "gridPageLogoWithCentralEl" : "gridPageLogo", item: true },
                React.createElement(Link, { to: props.logoLink },
                    React.createElement(ButtonBase, { "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: props.onLogoClick, style: { marginTop: 10, marginBottom: 10, height: logoHeight } },
                        React.createElement("div", { style: {
                                height: logoHeight,
                                width: logoWidth,
                                backgroundPosition: 'left center',
                                backgroundImage: "url(" + props.imageSource + ")",
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat'
                            } }))));
        }
        else {
            return React.createElement(Grid, { className: props.centralElement ? "gridPageLogoWithCentralEl" : "gridPageLogo", item: true },
                React.createElement(ButtonBase, { "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: props.onLogoClick, style: { marginTop: 10, marginBottom: 10, height: logoHeight } },
                    React.createElement("div", { style: {
                            height: logoHeight,
                            width: logoWidth,
                            backgroundPosition: 'left center',
                            backgroundImage: "url(" + props.imageSource + ")",
                            backgroundSize: 'contain',
                            backgroundRepeat: 'no-repeat'
                        } })));
        }
    }
    function getTranslationData(language) {
        return language === 'de' ? deData : enData;
    }
    return (React.createElement(AppBar, { className: "appBar" },
        React.createElement(Toolbar, { className: "toolbar", id: "libraryToolbar" },
            React.createElement("div", { id: "libraryMenudiv" },
                React.createElement(Grid, { container: true, direction: "row", alignItems: "center", justify: props.centralElement ? "center" : undefined },
                    leftSidebarInDOM && React.createElement(Grid, { item: true },
                        React.createElement("div", { style: {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            } },
                            React.createElement("span", { className: "menuIcon", onClick: function () {
                                    handleShowLeftSidebar(true);
                                } }, "\u2630"))),
                    renderLogo(),
                    React.createElement("div", { style: { position: "absolute", transform: "translate(-50%, 0)", left: "50%" } }, props.centralElement),
                    React.createElement("div", { id: "menuContent", className: "libraryMenuContent", style: props.centralElement ? { marginLeft: "150px" } : { marginLeft: "auto" } },
                        React.createElement("a", { className: "closebtn", onClick: function () {
                                handleShowLeftSidebar(false);
                            } }, "\u00D7"),
                        React.createElement(Grid, { item: true },
                            React.createElement(Grid, { container: true, className: "mainGrid", spacing: 0 },
                                renderMenuItems(),
                                renderNestedMenuItems(props.nestedItems),
                                React.createElement(Grid, { id: "userGrid", className: "libraryUserGrid", item: true },
                                    React.createElement(ButtonBase, { style: { padding: '10px' }, "aria-controls": "simple-menu", "aria-haspopup": "true", onClick: handleUserItemClick },
                                        React.createElement(PersonIcon, null),
                                        React.createElement(Typography, { className: "printBackground", variant: 'inherit', style: { fontSize: 14 }, color: 'inherit' }, props.username)),
                                    React.createElement(Menu, { anchorEl: userAnchorEl, open: Boolean(userAnchorEl), onClose: handleUserMenuClose },
                                        renderUserMenuItems(),
                                        React.createElement(MenuItem, { onClick: function () {
                                                props.signout();
                                                handleUserMenuClose();
                                            } },
                                            React.createElement(Typography, { className: "printBackground", variant: 'inherit', style: { fontSize: 16 }, color: 'inherit' }, getTranslationData(props.language).logout))))))))))));
};
var useStyles = makeStyles(function () { return ({
    popperStyle: {
        zIndex: 10,
    },
}); });
export var Menu = function (_a) {
    var children = _a.children, open = _a.open, anchorEl = _a.anchorEl, onClose = _a.onClose;
    var classes = useStyles();
    return (React.createElement(Popper, { className: classes.popperStyle, disablePortal: true, open: open, anchorEl: anchorEl, role: undefined, transition: true, placement: "bottom-end" },
        React.createElement(Paper, null,
            React.createElement(ClickAwayListener, { onClickAway: onClose },
                React.createElement(MenuList, null, children)))));
};
export default MenuNav;
//# sourceMappingURL=Menu.js.map